import { render, staticRenderFns } from "./SettingsChoice.vue?vue&type=template&id=30efc2e2&scoped=true"
import script from "./SettingsChoice.vue?vue&type=script&lang=js"
export * from "./SettingsChoice.vue?vue&type=script&lang=js"
import style0 from "./SettingsChoice.vue?vue&type=style&index=0&id=30efc2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30efc2e2",
  null
  
)

export default component.exports